export const springestHref = 'https://www.springest.nl/business-performance-academy/prijs-onderhandelen';